import { isArray, isNil, isObject } from 'lodash-es';

import type {
  MetadataValue,
  MetadataValues,
} from '@iconik-io/iconik-api/src/schema_patched/metadata';

export const elasticToForm = (
  data: MetadataValues = {},
  fieldsPrefix = '',
): MetadataValues => {
  const metadataValues: MetadataValues = {};
  let value: MetadataValue;
  Object.keys(data).forEach((key) => {
    value = data[key];
    if (isNil(data[key])) {
      value = [];
    } else if (isArray(value)) {
      value = value.map((v) =>
        isObject(v)
          ? { ...v, value: String(v.value ?? '') }
          : { value: String(v) },
      );
    } else if (!isArray(value)) {
      value = value !== undefined ? [{ value: String(value) }] : undefined;
    }
    metadataValues[fieldsPrefix + key] = value;
  });

  return metadataValues;
};
